import React from "react";
import styled from "styled-components";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";
import BannerTrandingNft from "./BannerTrendingNft";

import TrendingWeapons from "./TrendingWeapons";

const Root = styled.div`
  padding-bottom: ${(p) => p.theme.spacing.sm};
  margin-bottom: 60px;
`;
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  @media (max-width: ${(p) => p.theme.screen.lg}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: calc(100% - 40px);
  }
`;

const TrendingNfts = ({ allContractDetails }) => {
  return (
    <Root>
      <Container>
        <NftMarketHomepage allContractDetails={allContractDetails} />
        <BannerTrandingNft />
        <TrendingWeapons />
      </Container>
    </Root>
  );
};
export default TrendingNfts;
